module.exports = __webpack_public_path__ + "static/switch-logo-v300-c7e4367b3add59bd6bee46a89cea80a0.png";